export function isDownloadFile(url) {
	return url.includes('data:');
}
